import * as yup from 'yup'

const sellerReqDetails = {
    quotQty : 0,
    quotLeadTime : 0,
    quotListPrice : 0,
    quotHSNCode : 0,
    //quotDiscountRate : 0,
    quotUnitPrice : 0,
    //quotGSTRate : 0
}

const sellerReqSchema = yup.array().of(
    yup.object().shape({
        // quotQty: yup.number().when("statusId", {
        //     is: 1,
        //     then : () => yup.number().transform(value => (value) ? parseInt(value) : null).nullable().required('This Field is required')
        // }),
        quotLeadTime: yup.number().when(["statusId", "quotQty", "quotUnitPrice"], {
            is: (statusId, quotQty, quotUnitPrice) => statusId === 1 && quotQty > 0 && quotUnitPrice > 0,
            then : () => yup.number().transform(value => (value) ? parseInt(value) : null).nullable().required('This Field is required')
        }),
        quotListPrice: yup.number().when(["statusId", "quotQty", "quotUnitPrice"], {
            is: (statusId, quotQty, quotUnitPrice) => statusId === 1 && quotQty > 0 && quotUnitPrice > 0,
            then : () => yup.number().transform(value => (value) ? parseInt(value) : null).nullable().required('This Field is required')
        }),
        quotHSNCode: yup.number().when(["statusId", "quotQty", "quotUnitPrice"], {
            is: (statusId, quotQty, quotUnitPrice) => statusId === 1 && quotQty > 0 && quotUnitPrice > 0,
            then : () => yup.number().transform(value => (value) ? parseInt(value) : null).nullable().required('This Field is required'),
            otherwise : () => yup.number().notRequired()
        }),
        quotUnitPrice: yup.number().when(["statusId", "quotQty", "quotTotalAmountBeforeTax"], {
            is: (statusId, quotQty, quotTotalAmountBeforeTax) => statusId === 1 && quotQty > 0 && quotTotalAmountBeforeTax > 0,
            then : () => yup.number().transform(value => (value) ? parseInt(value) : null).nullable().required('This Field is required')
        }),
        quotGSTRate: yup.number().when(["statusId", "quotQty", "gstinCode", "quotUnitPrice"], {
            is: (statusId, quotQty, gstinCode, quotUnitPrice) => statusId === 1 && quotQty > 0 && gstinCode !== null && quotUnitPrice > 0,
            then : () => yup.number().transform(value => (value) && parseInt(value) ).required('This Field is required'),
            otherwise : () => yup.number().notRequired()
        }),
    })
)

export { sellerReqDetails, sellerReqSchema }